import styled from 'styled-components';
import { GenericCardWrapper } from '../../sharedStyles';

export const Wrapper = styled.div`
  max-width: 570px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CardWarningWrapper = styled(GenericCardWrapper)`
  padding: 24px 40px;
  margin-bottom: 37px;
  @media (max-width: 570px) {
    padding: 24px 20px;
  }
`;

export const CardWarningTitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.main};
  span {
    font-weight: 700;
    display: block;
  }
`;

export const CardWarningList = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 22px;
  display: flex;
  gap: 10px;
  color: ${({ theme }) => theme.colors.main};
  div {
    padding: 30px 15px;
    flex: 1;
    svg {
      display: block;
      height: 160px;
      margin: auto;
    }
  }
  ul {
    list-style: disc;
  }
  li {
    margin: 0 0 9px;
    display: list-item;
    list-style: disc;
  }
  @media (max-width: 570px) {
    div:nth-child(1) {
      display: none;
    }
  }
`;

export const CardWarningPhotoVideo = styled.div`
  position: relative;
  width: 100%;
  max-width: 438px;
  padding: 0 20px;
  margin: auto;
  background: ${({ theme }) => theme.colors.mainDark};
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  .CardWarning-photoVideoBlock {
    div {
      display: inline-block;
      width: calc(100% - 66px);
      max-width: 315px;
      padding: 20px 0;
      vertical-align: middle;
    }
    svg {
      display: inline-block;
      width: 25px;
      height: 20px;
      margin: 0 20px;
      vertical-align: super;
    }
    @media (max-width: 570px) {
      div {
        width: calc(100% - 36px);
      }
      svg {
        margin: 0 10px 0 0;
      }
    }
  }
  hr {
    border: none;
    height: 1px;
    background-color: #fff;
  }
  span {
    display: block;
    font-weight: 500;
  }
`;

export const CardWarningTooltip = styled.div`
  position: absolute;
  top: 6px;
  right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
  }
`;
